export default __webpack_public_path__ + "static/media/regione.fb14a67d.png";